import {
  cleanupEmissionConsumptionMarkup,
  getConsumptionsAndEmissionsWithIdentifiers,
} from '@oneaudi/feature-app-utils';
import type { ReactNode } from 'react';
import type {
  VueFormatterFeatureServiceInterface,
  LocaleService,
} from '../../types/feature-service-types';
import { renderTextWithFootnotesReferences } from '../../types/feature-service-types';

export interface ConsumptionEmissionValue {
  consumption: ReactNode;
  emission: ReactNode;
}

export interface WltpProps {
  formattedConsumption?: Iterable<ReactNode> | string | undefined;
  formattedEmission?: Iterable<ReactNode> | undefined;
  formattedCo2Class?: Iterable<ReactNode> | undefined;
  formattedDischargedCo2Class?: Iterable<ReactNode> | undefined;
  formattedDischargedConsumption?: Iterable<ReactNode> | undefined;
}

type ConsumptionAndEmissionFormatterValue = {
  formattedConsumption?: string;
  formattedEmission?: string;
  formattedCo2Class?: string;
  formattedDischargedCo2Class?: string;
  formattedDischargedConsumption?: string;
};

type myCallBack = (wltp: WltpProps[]) => void;
export class VueServiceHelper {
  static getConsumptionAndEmission = async (
    wltpValues: string[],
    mycallback: myCallBack,
    vueFormatterFeatureService: VueFormatterFeatureServiceInterface,
    localeService: LocaleService,
  ) => {
    const wltp: WltpProps[] = [];

    const consumptionsAndEmissionsValues = await getConsumptionsAndEmissionsWithIdentifiers(
      wltpValues,
      vueFormatterFeatureService,
      localeService,
    );

    wltpValues.forEach((wltpKey: string) => {
      const wltpData: WltpProps = {};
      const consumptionAndEmissionValue = (
        consumptionsAndEmissionsValues as Record<
          string,
          ConsumptionAndEmissionFormatterValue | undefined
        >
      )[wltpKey];

      if (!consumptionAndEmissionValue) {
        return;
      }

      const {
        formattedConsumption,
        formattedEmission,
        formattedCo2Class,
        formattedDischargedCo2Class,
        formattedDischargedConsumption,
      } = consumptionAndEmissionValue;

      if (formattedConsumption && formattedEmission) {
        wltpData.formattedConsumption = renderTextWithFootnotesReferences(
          cleanupEmissionConsumptionMarkup(formattedConsumption),
        );
        wltpData.formattedEmission = renderTextWithFootnotesReferences(
          cleanupEmissionConsumptionMarkup(formattedEmission),
        );

        if (formattedCo2Class) {
          wltpData.formattedCo2Class = renderTextWithFootnotesReferences(
            cleanupEmissionConsumptionMarkup(formattedCo2Class),
          );
        }

        if (formattedDischargedCo2Class) {
          wltpData.formattedDischargedCo2Class = renderTextWithFootnotesReferences(
            cleanupEmissionConsumptionMarkup(formattedDischargedCo2Class),
          );
        }

        if (formattedDischargedConsumption) {
          wltpData.formattedDischargedConsumption = renderTextWithFootnotesReferences(
            cleanupEmissionConsumptionMarkup(formattedDischargedConsumption),
          );
        }

        if (Object.keys(wltpData).length > 0) {
          wltp.push(wltpData);
        }
      }
    });
    mycallback(wltp);
  };

  static isAudiCode(value: string): boolean {
    const audiCodeRegExp = /^[A-Z0-9]+$/;
    return audiCodeRegExp.test(value);
  }

  static isCarLineCode(value: string): boolean {
    const carlineRegExp = /^[a-z0-9_-]+$/;
    return carlineRegExp.test(value);
  }
}
